import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { DriverProfileService } from 'src/app/services/driver-profile/driver-profile.service';

@Component({
  selector: 'app-view-drivers',
  templateUrl: './view-drivers.page.html',
  styleUrls: ['./view-drivers.page.scss'],
})
export class ViewDriversPage implements OnInit {
  drivers = [];
  loading: HTMLIonLoadingElement;

  constructor(
    private driversService: DriverProfileService,
    private loadingController: LoadingController
  ) {}

  ngOnInit() {
    this.getDrivers();
  }

  getDrivers() {
    this.driversService.getDrivers().subscribe((res) => {
      if (!res.empty) {
        this.drivers = res.docs.map((res) => res.data());
      }
    });
  }

  setToOnDuty(userID) {
    this.presentLoading();
    this.driversService
      .setDriverOnDuty(userID)
      .then(() => {
        this.getDrivers();
        this.dismissLoading();
      })
      .catch((e) => {
        this.dismissLoading();
      });
  }

  setToOffDuty(userID) {
    this.presentLoading();
    this.driversService
      .setDriverOffDuty(userID)
      .then(() => {
        this.getDrivers();
        this.dismissLoading();
      })
      .catch((e) => {
        this.dismissLoading();
      });
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'loading...',
    });
    await this.loading.present();
  }

  async dismissLoading() {
    this.loading.dismiss();
  }
}
